const elasticSearchResults = (state = {}, action) => {
  switch (action.type) {
    default: return state;
  }
};

export default elasticSearchResults;
